import labsIndividuales from '../img/servicios/labs-individuales.png';
import labsPoliticas from '../img/servicios/labs-politicas.png';
import labsColectivos from '../img/servicios/labs-colectivos.png';

const serviciosData = [
  {
    id: 'coaching',

    titulo: {
      es: 'Coaching individual',
      en: 'Individual coaching',
    },

    resumen: {
      es: 'Un espacio para ganar claridad, explorar posibilidades y avanzar hacia tus objetivos.',

      en: 'A space to gain clarity, explore possibilities and move towards your goals.',
    },

    descripcion: {
      es: 'Procesos personalizados para comprender tu situación, definir objetivos y avanzar de forma consciente.',

      en: 'Personalised processes to understand your situation, define your goals and move forward consciously.',
    },

    imagen: labsIndividuales,

    opciones: [
      {
        id: 'idea-accion',

        titulo: {
          es: 'De la idea a la acción',
          en: 'From idea to action',
        },

        subtitulo: {
          es: 'Claridad, coherencia y primer movimiento.',

          en: 'Clarity, coherence and the first step forward.',
        },

        descripcion: {
          es: 'Te ayudo a aterrizar una idea, descubrir su coherencia con tu esencia y convertirla en un plan de acción concreto y realista.',

          en: 'I help you bring an idea down to earth, explore how it aligns with who you are and turn it into a concrete and realistic action plan.',
        },

        dirigidoA: {
          es: 'Personas con una idea, proyecto o cambio personal que sienten que está ahí, pero no acaba de arrancar.',

          en: 'People with an idea, project or personal change that feels present but has not yet managed to get started.',
        },

        formato: {
          es: 'Proceso de 4 a 6 sesiones individuales o intensivo de 1 a 2 días.',

          en: 'A process of 4 to 6 individual sessions or a 1-to-2-day intensive.',
        },
      },

      {
        id: 'reorientacion',

        titulo: {
          es: 'Reorientación profesional y de vida',

          en: 'Career and life redirection',
        },

        subtitulo: {
          es: 'Diseña el siguiente capítulo de tu trayectoria.',

          en: 'Design the next chapter of your journey.',
        },

        descripcion: {
          es: 'Acompañamiento para revisar tu carrera, valores y estilo de vida, y construir un nuevo rumbo con más sentido y sostenibilidad.',

          en: 'Support to review your career, values and lifestyle and build a new direction with greater purpose and sustainability.',
        },

        dirigidoA: {
          es: 'Profesionales en transición, agotados de su actual camino o que quieren reinventarse.',

          en: 'Professionals in transition who feel exhausted by their current path or want to reinvent themselves.',
        },

        formato: {
          es: 'Proceso de 6 a 8 sesiones individuales.',

          en: 'A process of 6 to 8 individual sessions.',
        },
      },

      {
        id: 'reactiva-proyecto',

        titulo: {
          es: 'Reactiva tu proyecto',
          en: 'Reactivate your project',
        },

        subtitulo: {
          es: 'Diagnóstico y plan de reactivación.',

          en: 'Assessment and reactivation plan.',
        },

        descripcion: {
          es: 'Analizamos por qué tu proyecto, negocio o iniciativa no está funcionando como debería y diseñamos las acciones concretas para reactivarlo.',

          en: 'We analyse why your project, business or initiative is not working as it should and design concrete actions to reactivate it.',
        },

        dirigidoA: {
          es: 'Emprendedores, freelancers o responsables de proyectos que sienten estancamiento o pérdida de tracción.',

          en: 'Entrepreneurs, freelancers and project managers experiencing stagnation or a loss of momentum.',
        },

        formato: {
          es: 'Proceso de 4 a 6 sesiones más entrega de hoja de ruta.',

          en: 'A process of 4 to 6 sessions, including the delivery of a roadmap.',
        },
      },
    ],
  },

  {
    id: 'facilitacion',

    titulo: {
      es: 'Facilitación y procesos colectivos',

      en: 'Facilitation and collective processes',
    },

    resumen: {
      es: 'Acompañamiento a grupos y organizaciones para construir caminos compartidos.',

      en: 'Support for groups and organisations to build shared paths.',
    },

    descripcion: {
      es: 'Procesos adaptados a equipos, grupos e instituciones.',

      en: 'Processes tailored to teams, groups and institutions.',
    },

    imagen: labsColectivos,

    opciones: [
      {
        id: 'cocreacion-resolucion',

        titulo: {
          es: 'Cocreación y resolución de problemas complejos',

          en: 'Co-creation and complex problem-solving',
        },

        subtitulo: {
          es: 'Talleres y procesos de cocreación.',

          en: 'Co-creation workshops and processes.',
        },

        descripcion: {
          es: 'Diseño y facilitación de espacios donde equipos y grupos generan soluciones a retos complejos de forma colaborativa y efectiva.',

          en: 'Design and facilitation of spaces where teams and groups collaboratively and effectively generate solutions to complex challenges.',
        },

        dirigidoA: {
          es: 'Equipos, departamentos, organizaciones y ecosistemas que necesitan abordar problemas que no se resuelven de forma lineal.',

          en: 'Teams, departments, organisations and ecosystems that need to address problems that cannot be solved through linear approaches.',
        },

        formato: {
          es: 'Taller de medio día a 2 días, o proceso de varias sesiones según la complejidad.',

          en: 'A half-day to 2-day workshop, or a multi-session process depending on the complexity.',
        },
      },

      {
        id: 'diseño-estructuracion-proyectos',

        titulo: {
          es: 'Diseño y estructuración de proyectos',

          en: 'Project design and structuring',
        },

        subtitulo: {
          es: 'De la idea al proyecto sólido (incluye intraemprendimiento).',

          en: 'From an idea to a solid project, including intrapreneurship.',
        },

        descripcion: {
          es: 'Te ayudo a mejorar la estructura de proyectos existentes o a diseñar otros nuevos —también desde dentro de una organización— de forma clara, viable y alineada.',

          en: 'I help you improve the structure of existing projects or design new ones —including from within an organisation— in a clear, viable and aligned way.',
        },

        dirigidoA: {
          es: 'Emprendedores, equipos de innovación, responsables de proyectos e intraemprendedores.',

          en: 'Entrepreneurs, innovation teams, project managers and intrapreneurs.',
        },

        formato: {
          es: 'Proceso de acompañamiento de 4 a 8 sesiones o taller intensivo con seguimiento.',

          en: 'A support process of 4 to 8 sessions or an intensive workshop with follow-up.',
        },
      },

      {
        id: 'mejora-experiencias-formativas',

        titulo: {
          es: 'Mejora de experiencias formativas',

          en: 'Improving learning experiences',
        },

        subtitulo: {
          es: 'Diseño y rediseño de formaciones que funcionan.',

          en: 'Designing and redesigning training that works.',
        },

        descripcion: {
          es: 'Revisión y mejora de programas formativos para que sean más experienciales, relevantes y generen un aprendizaje real.',

          en: 'Review and improvement of training programmes to make them more experiential, relevant and capable of generating meaningful learning.',
        },

        dirigidoA: {
          es: 'Formadores, áreas de Learning & Development, escuelas y organizaciones que ofrecen formación.',

          en: 'Trainers, Learning & Development departments, schools and organisations that provide training.',
        },

        formato: {
          es: 'Proceso de consultoría y facilitación —normalmente de 3 a 6 sesiones— o taller de diseño colaborativo.',

          en: 'A consulting and facilitation process, usually involving 3 to 6 sessions, or a collaborative design workshop.',
        },
      },

      {
        id: 'construccion-redes-consorcios-captacion-fondos',

        titulo: {
          es: 'Construcción de redes, consorcios y captación de fondos',

          en: 'Network and consortium building and fundraising',
        },

        subtitulo: {
          es: 'Activa tu ecosistema y canaliza recursos.',

          en: 'Activate your ecosystem and channel resources.',
        },

        descripcion: {
          es: 'Talleres y acompañamiento para reactivar comunidades y carteras de contactos, construir consorcios y mejorar la canalización de fondos en entornos de innovación.',

          en: 'Workshops and support to reactivate communities and contact networks, build consortia and improve access to funding in innovation environments.',
        },

        dirigidoA: {
          es: 'Proyectos, startups, entidades y ecosistemas de innovación que necesitan aliados y financiación.',

          en: 'Projects, startups, organisations and innovation ecosystems that need partners and funding.',
        },

        formato: {
          es: 'Taller de 1 día o proceso de acompañamiento de varias sesiones.',

          en: 'A 1-day workshop or a support process involving several sessions.',
        },
      },
    ],
  },

  {
    id: 'cambio-sistemico',

    titulo: {
      es: 'Procesos de cambio sistémico y territorial',

      en: 'Systemic and territorial change processes',
    },

    resumen: {
      es: 'Transformaciones sostenibles conectadas con las necesidades de cada territorio.',

      en: 'Sustainable transformations connected to the needs of each territory.',
    },

    descripcion: {
      es: 'Acompañamiento de procesos complejos con diferentes agentes.',

      en: 'Support for complex processes involving different stakeholders.',
    },

    imagen: labsPoliticas,

    opciones: [
      {
        id: 'Laboratorio-de-innovacion-territorial-para-políticas-públicas',

        titulo: {
          es: 'Laboratorio de innovación territorial para políticas públicas',

          en: 'Territorial innovation laboratory for public policy',
        },

        subtitulo: {
          es: 'Genera soluciones sostenibles para los retos territoriales.',

          en: 'Generate sustainable solutions to territorial challenges.',
        },

        descripcion: {
          es: 'Fomenta la colaboración entre diferentes actores para diseñar e implementar soluciones innovadoras y sostenibles en contextos territoriales específicos.',

          en: 'It promotes collaboration between different stakeholders to design and implement innovative and sustainable solutions in specific territorial contexts.',
        },

        dirigidoA: {
          es: 'Administraciones públicas, agencias de desarrollo territorial, universidades y organizaciones que trabajan en innovación territorial.',

          en: 'Public administrations, territorial development agencies, universities and organisations working in territorial innovation.',
        },

        formato: {
          es: 'Proceso extensivo, a acordar con el cliente.',

          en: 'An extensive process to be agreed with the client.',
        },
      },

      {
        id: 'teoria-cambio-aplicada',

        titulo: {
          es: 'Teoría de Cambio aplicada',

          en: 'Applied Theory of Change',
        },

        subtitulo: {
          es: 'Diseña el cambio que realmente quieres generar.',

          en: 'Design the change you genuinely want to create.',
        },

        descripcion: {
          es: 'Taller práctico en el que instituciones y equipos construyen su propia Teoría de Cambio a partir de un caso real, clarificando el impacto deseado, los supuestos, los indicadores y la ruta de intervención.',

          en: 'A practical workshop in which institutions and teams build their own Theory of Change from a real case, clarifying the desired impact, assumptions, indicators and intervention pathway.',
        },

        dirigidoA: {
          es: 'Administraciones públicas, entidades del tercer sector, agencias de desarrollo y organizaciones que diseñan intervenciones complejas, como procesos urbanos, sociales o territoriales.',

          en: 'Public administrations, third-sector organisations, development agencies and organisations designing complex interventions, such as urban, social or territorial processes.',
        },

        formato: {
          es: 'Taller de 1 a 2 días —presencial o híbrido— con posibilidad de acompañamiento posterior.',

          en: 'A 1-to-2-day workshop, either in person or hybrid, with the possibility of subsequent support.',
        },
      },

      {
        id: 'challenge-led-system-mapping',

        titulo: {
          es: 'Mapeo sistémico orientado a desafíos para la descarbonización de territorios',

          en: 'Challenge-led systems mapping for territorial decarbonisation',
        },

        subtitulo: {
          es: 'Mapea el sistema y encuentra las palancas de cambio.',

          en: 'Map the system and identify the levers for change.',
        },

        descripcion: {
          es: 'Proceso de mapeo sistémico orientado a retos de descarbonización territorial. Identificamos actores, relaciones, puntos de apalancamiento y posibles rutas de intervención para acelerar la transición.',

          en: 'A systems-mapping process focused on territorial decarbonisation challenges. We identify stakeholders, relationships, leverage points and possible intervention pathways to accelerate the transition.',
        },

        dirigidoA: {
          es: 'Gobiernos locales y regionales, agencias de energía y clima, consorcios territoriales y equipos que trabajan en transiciones hacia la neutralidad climática.',

          en: 'Local and regional governments, energy and climate agencies, territorial consortia and teams working on transitions towards climate neutrality.',
        },

        formato: {
          es: 'Proceso de extensión variable en función de los objetivos del cliente.',

          en: 'A process of variable duration depending on the client’s objectives.',
        },
      },
    ],
  },
];

export default serviciosData;